import Reveal from "@/components/Reveal";
import { MapPin, Lock } from "lucide-react";

export default function Location() {
  return (
    <section data-testid="location" className="bg-white text-[#1C1917] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">The Studio</span>
          <h2 className="font-serif text-6xl sm:text-8xl font-medium leading-[0.9] tracking-tight mt-4">Moonee Ponds</h2>
          <p className="mt-7 text-lg text-[#1C1917]/70 leading-relaxed max-w-md">
            Private lash studio in Moonee Ponds, Melbourne — an intimate, one-on-one space.
          </p>
          <div className="mt-8 flex items-start gap-4 bg-[#FAF8F5] rounded-2xl p-5 max-w-md">
            <Lock size={18} className="text-[#C5B382] shrink-0 mt-0.5" strokeWidth={1.75} />
            <p className="text-sm text-[#1C1917]/70 leading-relaxed">
              Exact address and appointment instructions are provided after booking.
            </p>
          </div>
          <div className="mt-6 flex items-center gap-2 text-[#1C1917]/50 text-[11px] tracking-[0.15em] uppercase">
            <MapPin size={15} className="text-[#C5B382]" /> Moonee Ponds VIC 3039 · Australia
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="aspect-[4/3] overflow-hidden rounded-[1.5rem] shadow-card">
            <iframe
              title="Moonee Ponds map"
              data-testid="location-map"
              className="w-full h-full"
              loading="lazy"
              src="https://www.openstreetmap.org/export/embed.html?bbox=144.900%2C-37.775%2C144.940%2C-37.755&layer=mapnik&marker=-37.765%2C144.920"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
